(function() {
    'use strict';
    angular
        .module('jotApp')
        .factory('ScriptsReleases', ScriptsReleases);

    ScriptsReleases.$inject = ['$resource'];

    function ScriptsReleases ($resource) {
        var resourceUrl =  'api/scripts-releases/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': { method:'PUT' },
            'load': {
                url:'api/scripts-releases/inactive',
                method: 'GET',
                isArray: true
            },
            'search': {
                url:'api/scripts-releases/search',
                method: 'POST',
                isArray: true
            },
            'filterType': {
                url:'api/scripts-releases/scripts-type/:scriptsTypeId',
                method: 'GET',
                isArray: true
            }
        });
    }
})();
